var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg403Icon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 338,
    height: 240,
    viewBox: "0 0 338 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.159 147.5c3.11 31.778 26.728 60.164 59.365 61.058 30.716.845 58.255-19.357 88.57-22.403 31.793-3.189 54.912 11.014 77.657 30.634 19.614 16.909 44.187 32.79 69.305 13.558 27.231-20.852 35.012-61.655 32.609-93.401-2.371-31.308-15.634-60.103-36.792-82.073C257.705 11.084 187.531-9.961 126.849 4.564 64.119 19.58 2.35 78.21 9.159 147.5z",
    fill: "#F2F8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.924 142.267v23.214H86.638v22.321H59.852v-22.321H.924v-26.786l54.464-75.893h31.25v79.465h14.286zM59.852 94.052l-33.928 48.215h33.928V94.052z",
    fill: "url(#a20zl3dy2a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M306.543 121.241c4.178 1.543 7.878 3.739 11.101 6.589 2.745 2.374 5.311 5.58 7.699 9.616 2.387 3.918 3.581 8.904 3.581 14.959 0 4.868-1.075 9.557-3.223 14.068-2.149 4.512-5.252 8.489-9.311 11.932-3.939 3.443-8.773 6.233-14.502 8.37-5.73 2.018-12.235 3.027-19.517 3.027-8.116 0-15.159-1.009-21.127-3.027-5.849-2.018-10.743-4.274-14.682-6.767-4.655-2.85-8.535-6.114-11.638-9.795l16.114-16.918c2.149 2.494 4.655 4.749 7.52 6.768 2.387 1.662 5.371 3.205 8.952 4.63 3.581 1.306 7.64 1.959 12.176 1.959 7.162 0 12.533-1.544 16.114-4.631 3.581-3.086 5.371-6.885 5.371-11.397 0-4.511-1.73-8.31-5.192-11.397-3.462-3.087-8.594-4.63-15.398-4.63h-13.429v-22.261h12.534c5.371 0 9.549-1.365 12.533-4.095 2.984-2.85 4.476-6.53 4.476-11.041 0-4.037-1.492-7.42-4.476-10.151-2.984-2.73-7.162-4.096-12.533-4.096-3.82 0-7.222.653-10.206 1.959-2.984 1.187-5.491 2.493-7.52 3.918a36.86 36.86 0 0 0-6.446 5.698L239.4 78.501c2.865-3.443 6.326-6.53 10.385-9.26 3.461-2.375 7.878-4.512 13.249-6.411 5.372-2.019 11.817-3.028 19.337-3.028 6.446 0 12.235.95 17.368 2.85 5.252 1.78 9.669 4.273 13.249 7.479 3.701 3.087 6.506 6.767 8.416 11.041 2.029 4.155 3.044 8.607 3.044 13.356 0 4.987-.955 9.142-2.865 12.466-1.791 3.324-3.82 6.055-6.088 8.192a33.016 33.016 0 0 1-8.952 6.055z",
    fill: "url(#qm6yvlwgfb)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M212.407 36.892a2.551 2.551 0 0 0-2.867 2.293 2.55 2.55 0 0 0 2.294 2.866 2.55 2.55 0 0 0 2.866-2.293c.191-1.401-.828-2.675-2.293-2.866z",
    fill: "url(#n9pr6qmyyc)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m255.592 40.777-2.739-.319a17.235 17.235 0 0 0-.382-2.611l2.484-1.083a1.331 1.331 0 0 0 .701-1.72l-.382-.892c-.319-.7-1.083-.955-1.72-.7l-2.484 1.083a8.604 8.604 0 0 0-1.656-2.039l1.656-2.23c.446-.572.318-1.4-.255-1.846l-.828-.574c-.573-.445-1.401-.318-1.847.255l-1.656 2.23c-.765-.383-1.593-.765-2.484-.956l.318-2.739c.064-.7-.446-1.401-1.146-1.465l-.956-.127c-.701-.064-1.401.446-1.465 1.146l-.318 2.74c-.892.063-1.784.19-2.612.381l-1.083-2.484c-.318-.7-1.082-.955-1.719-.7l-.892.382a1.331 1.331 0 0 0-.701 1.72l1.083 2.484a8.603 8.603 0 0 0-2.038 1.656l-2.23-1.656c-.573-.446-1.401-.319-1.847.255l-.573.828c-.446.573-.318 1.4.255 1.847l2.229 1.656c-.382.764-.764 1.592-.955 2.484l-2.739-.319c-.701-.063-1.402.446-1.465 1.147l-.128 1.02c-.063.7.446 1.4 1.147 1.464l2.739.319c.064.891.191 1.783.382 2.611l-2.484 1.083a1.331 1.331 0 0 0-.701 1.72l.382.891c.319.637 1.083.956 1.72.701l2.484-1.083a8.604 8.604 0 0 0 1.656 2.038l-1.656 2.23c-.446.573-.318 1.401.255 1.847l.764.573c.574.446 1.402.319 1.848-.255l1.656-2.229c.764.382 1.592.765 2.484.956l-.319 2.738c-.063.701.446 1.402 1.147 1.465l.955.128c.701.063 1.401-.446 1.465-1.147l.319-2.739a17.193 17.193 0 0 0 2.611-.382l1.083 2.484c.318.701 1.083.956 1.72.701l.891-.382a1.331 1.331 0 0 0 .701-1.72l-1.083-2.484a8.61 8.61 0 0 0 2.039-1.656l2.229 1.656c.573.446 1.401.318 1.847-.255l.573-.828c.446-.573.319-1.401-.254-1.847l-2.23-1.656c.382-.764.765-1.593.956-2.484l2.739.318c.7.064 1.401-.446 1.464-1.146l.128-.956c.191-.764-.382-1.401-1.083-1.528zm-7.197 1.019c-.446 4.204-4.204 7.197-8.408 6.752a7.512 7.512 0 0 1-6.688-8.408 7.513 7.513 0 0 1 8.408-6.688c4.14.446 7.133 4.204 6.688 8.344z",
    fill: "url(#nbhfn9r6kd)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M241.261 37.018c-2.166-.255-4.141 1.338-4.395 3.503-.255 2.166 1.337 4.14 3.503 4.395 2.166.255 4.14-1.337 4.395-3.503a3.948 3.948 0 0 0-3.503-4.395z",
    fill: "url(#iyjiso95le)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m112.822 206.217-1.942-.226a12.222 12.222 0 0 0-.271-1.851l1.761-.768c.497-.225.677-.767.497-1.219l-.271-.632a.945.945 0 0 0-1.219-.497l-1.762.768a6.075 6.075 0 0 0-1.174-1.445l1.174-1.581c.317-.406.226-.993-.18-1.309l-.587-.407c-.407-.316-.994-.225-1.31.181l-1.174 1.58c-.542-.271-1.129-.541-1.761-.677l.226-1.942c.045-.496-.316-.993-.813-1.038l-.677-.091c-.497-.045-.994.316-1.039.813l-.226 1.942c-.632.045-1.264.135-1.851.271l-.768-1.761c-.226-.497-.768-.678-1.22-.497l-.632.271c-.496.226-.677.768-.496 1.219l.767 1.761a6.112 6.112 0 0 0-1.445 1.174l-1.58-1.174c-.407-.316-.993-.225-1.31.181l-.406.587c-.316.406-.226.994.18 1.31l1.581 1.174c-.27.542-.542 1.129-.677 1.761l-1.942-.226c-.497-.045-.994.316-1.039.813l-.09.722c-.045.497.316.994.813 1.039l1.942.226c.045.632.135 1.264.27 1.851l-1.76.768c-.497.226-.678.768-.497 1.219l.27.632c.226.452.768.678 1.22.497l1.761-.768a6.115 6.115 0 0 0 1.174 1.446l-1.174 1.58c-.316.406-.226.993.18 1.31l.543.406c.406.316.993.226 1.31-.181l1.173-1.58c.542.271 1.13.542 1.761.677l-.225 1.942c-.046.497.316.993.812 1.039l.678.09c.496.045.993-.316 1.038-.813l.226-1.942a12.11 12.11 0 0 0 1.852-.271l.767 1.762c.226.496.768.677 1.22.496l.632-.271c.496-.225.677-.767.496-1.219l-.767-1.761a6.12 6.12 0 0 0 1.445-1.174l1.58 1.174a.937.937 0 0 0 1.31-.181l.406-.587c.316-.406.226-.993-.18-1.309l-1.581-1.174c.271-.542.542-1.129.678-1.762l1.941.226c.497.045.994-.316 1.039-.813l.09-.677a.882.882 0 0 0-.767-1.084zm-5.103.723a5.326 5.326 0 0 1-5.961 4.741 5.325 5.325 0 0 1-4.742-5.96 5.326 5.326 0 0 1 5.961-4.742c2.935.316 5.058 2.98 4.742 5.961z",
    fill: "url(#9w1qiwe4ff)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.661 203.554c-1.535-.18-2.935.948-3.116 2.484-.18 1.535.949 2.935 2.484 3.116 1.535.18 2.935-.949 3.116-2.484.18-1.58-.903-2.935-2.484-3.116z",
    fill: "url(#k6kfi7wpbg)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m93.54 192.399-2.89-.316a14.433 14.433 0 0 0-.407-2.799l2.664-1.174a1.39 1.39 0 0 0 .723-1.852l-.407-.948a1.39 1.39 0 0 0-1.851-.723l-2.665 1.174a11.834 11.834 0 0 0-1.76-2.212l1.715-2.349c.452-.632.316-1.49-.316-1.987l-.858-.632c-.632-.451-1.49-.316-1.987.316l-1.716 2.349a16.6 16.6 0 0 0-2.619-1.039l.316-2.89a1.376 1.376 0 0 0-1.219-1.535l-1.038-.136c-.768-.09-1.49.452-1.536 1.219l-.316 2.89c-.948.046-1.897.181-2.8.407l-1.174-2.664c-.316-.723-1.129-1.039-1.851-.723l-.949.406a1.39 1.39 0 0 0-.722 1.852l1.174 2.664a11.875 11.875 0 0 0-2.213 1.761l-2.348-1.716c-.632-.451-1.49-.316-1.987.316l-.632.858c-.452.633-.316 1.491.316 1.987l2.348 1.716c-.451.813-.767 1.716-1.038 2.619l-2.89-.316a1.378 1.378 0 0 0-1.536 1.22l-.135 1.038c-.09.768.451 1.49 1.264 1.536l2.89.316c.045.948.18 1.896.407 2.799l-2.665 1.175c-.722.316-1.038 1.128-.722 1.851l.406.948c.316.723 1.13 1.039 1.852.723l2.664-1.174a11.83 11.83 0 0 0 1.761 2.212l-1.716 2.349c-.451.632-.316 1.49.316 1.987l.858.632c.632.451 1.49.316 1.987-.316l1.716-2.349c.813.452 1.716.768 2.62 1.039l-.317 2.89c-.09.768.452 1.49 1.22 1.581l1.038.135a1.377 1.377 0 0 0 1.535-1.219l.317-2.89a14.408 14.408 0 0 0 2.8-.407l1.173 2.665c.316.722 1.13 1.038 1.852.722l.948-.406c.723-.316 1.039-1.129.723-1.852l-1.174-2.664a11.878 11.878 0 0 0 2.212-1.761l2.348 1.716c.633.451 1.49.316 1.987-.316l.632-.858c.452-.632.317-1.49-.316-1.987l-2.348-1.716c.452-.813.768-1.716 1.039-2.619l2.89.316c.768.09 1.49-.452 1.535-1.219l.136-1.039c.045-.768-.497-1.49-1.265-1.581zm-7.677 1.084c-.497 4.426-4.516 7.632-8.942 7.135-4.425-.497-7.631-4.516-7.134-8.941.496-4.425 4.515-7.632 8.94-7.135 4.471.497 7.632 4.516 7.136 8.941z",
    fill: "url(#jv0v83fi4h)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M78.321 188.424c-2.303-.271-4.425 1.4-4.65 3.703-.272 2.303 1.399 4.425 3.702 4.651 2.303.271 4.425-1.4 4.651-3.703.271-2.303-1.4-4.425-3.703-4.651z",
    fill: "url(#h3ovgw0yfi)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M170.941 189.187c37.289 0 67.517-30.229 67.517-67.517 0-37.289-30.228-67.517-67.517-67.517-37.288 0-67.517 30.228-67.517 67.517 0 37.288 30.229 67.517 67.517 67.517z",
    fill: "url(#1an36awm7j)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M218.924 106.801h-96v30h96v-30z",
    fill: "url(#9qmfraiick)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#2exs5ilk5l)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.66 91.415c-8.025 0-14.522-6.37-14.522-14.204 0-7.834 6.496-14.268 14.522-14.268 1.147 0 2.357.128 3.44.383l1.082.254.064-1.019c1.083-10.191 9.682-17.834 20.064-17.834 7.962 0 15.223 4.586 18.408 11.783l.255.51.573.063c5.159.319 9.618 3.758 11.21 8.536l.319.955.955-.382a13.262 13.262 0 0 1 4.968-.956c7.325 0 13.313 5.86 13.313 13.058 0 7.006-5.542 12.739-12.676 13.057H102.66v.064z",
    fill: "url(#tffwiq3qlm)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ks6vbezv1n)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.152 192.372c-6.943 0-12.548-5.542-12.548-12.357 0-6.815 5.605-12.357 12.548-12.357 1.019 0 2.038.128 2.994.382l1.082.255.128-1.083c.892-8.79 8.408-15.478 17.389-15.478 6.879 0 13.185 4.013 15.987 10.192l.255.509.573.064c4.459.255 8.344 3.248 9.682 7.388l.318.956.956-.382c1.337-.51 2.802-.828 4.267-.828 6.37 0 11.529 5.095 11.529 11.337 0 6.051-4.841 11.02-10.955 11.338H212.152v.064z",
    fill: "url(#ko27s1a6jo)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a20zl3dy2a",
    x1: 2.836,
    y1: 108.721,
    x2: 109.341,
    y2: 165.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.089,
    stopColor: "#2559CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#002295"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qm6yvlwgfb",
    x1: 239.495,
    y1: 108.266,
    x2: 342.764,
    y2: 160.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.089,
    stopColor: "#2559CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#002295"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n9pr6qmyyc",
    x1: 209.52,
    y1: 39.471,
    x2: 214.721,
    y2: 39.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.089,
    stopColor: "#98B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nbhfn9r6kd",
    x1: 225.023,
    y1: 40.928,
    x2: 256.704,
    y2: 40.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.089,
    stopColor: "#98B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iyjiso95le",
    x1: 236.841,
    y1: 40.965,
    x2: 244.79,
    y2: 40.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.089,
    stopColor: "#98B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9w1qiwe4ff",
    x1: 91.149,
    y1: 206.325,
    x2: 113.61,
    y2: 206.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.089,
    stopColor: "#98B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k6kfi7wpbg",
    x1: 99.528,
    y1: 206.353,
    x2: 105.163,
    y2: 206.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.089,
    stopColor: "#98B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jv0v83fi4h",
    x1: 60.937,
    y1: 192.572,
    x2: 94.797,
    y2: 192.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.089,
    stopColor: "#98B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h3ovgw0yfi",
    x1: 73.644,
    y1: 192.599,
    x2: 82.051,
    y2: 192.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.089,
    stopColor: "#98B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "1an36awm7j",
    x1: 188.139,
    y1: 163.198,
    x2: 136.546,
    y2: 78.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#2559CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#4567DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9qmfraiick",
    x1: 122.954,
    y1: 121.794,
    x2: 218.898,
    y2: 121.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.089,
    stopColor: "#98B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tffwiq3qlm",
    x1: 132.724,
    y1: 44.727,
    x2: 132.724,
    y2: 91.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.092,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#fff",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F6F9FB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ko27s1a6jo",
    x1: 238.458,
    y1: 151.734,
    x2: 238.458,
    y2: 192.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451,
    stopColor: "#fff",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F9FB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "2exs5ilk5l",
    x: 82.138,
    y: 38.727,
    width: 101.173,
    height: 58.688,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_307_574"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_307_574",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ks6vbezv1n",
    x: 193.604,
    y: 145.734,
    width: 89.708,
    height: 52.638,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_307_574"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_307_574",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg403Icon);
export default __webpack_public_path__ + "static/media/403-icon.d4aea6aacbbab9cee972c0fbb35026ae.svg";
export { ForwardRef as ReactComponent };